<template>
<!-- <v-scale-screen width="1920" height="1080"> -->
  <nav-header></nav-header>
  <router-view v-wechat-title="$t($route.meta.title)"></router-view>
  <nav-footer></nav-footer>
<!-- </v-scale-screen> -->
</template>

<script>
// import VScaleScreen from 'v-scale-screen'
import NavHeader from './navHeader.vue'
import NavFooter from './navFooter.vue'
export default {
  name: 'App',
  components: {
    NavHeader,
    NavFooter
  }
}
</script>

<style>
/* 字体栈与排版基线统一由 src/style/typography.css 提供，
   此处仅保留 #app 的层叠上下文与字号继承 */
#app {
  font-family: var(--font-sans);
  font-size: var(--fs-body);
  line-height: var(--lh-body);
}
</style>
